<app-admin-dashboard>
  <div class="card">
    <span *ngIf="saleType === 'marketplace'" class="text-sm font-normal module-title">
      {{'AdminExportOffer.MarketplaceModuleTitle' | translate}}
    </span>
    <span *ngIf="saleType === 'program'" class="text-sm font-normal module-title">
      {{'AdminExportOffer.ProgramModuleTitle' | translate}}
    </span>
    <div class="mb-3"></div>

    <div class="header-card separator pt-0">
      <div class="w-3 container-title">
        <h1 class="text-xl font-medium text-800 m-0">
          {{'AdminExportOffer.PageTitle' | translate}}
        </h1>
      </div>
      <div class="w-9 flex align-items-center justify-content-start flex-wrap">
        <span class="p-input-icon-left justify-content-start flex w-6">
          <i class="pi pi-search custom-input-icon"></i>
          <input [(ngModel)]="searchTerm" (input)="onFilter()" type="text" pInputText
            placeholder="{{'AdminExportOffer.SearchInput' | translate}}"
            class="p-inputtext-sm custom-input bg-form w-full" />
        </span>
      </div>
    </div>

    <div class="body-card">
      <form [formGroup]="filterForm">
        <div class="flex flex-row justify-content-between flex-wrap align-items-center align-content-center py-3">
          <div class="flex flex-row">
            <div class="container-select">
              <p-dropdown
                formControlName="offerId"
                placeholder="{{'AdminExportOffer.Table.OfferIdFilter' | translate}}"
                [options]="offersFilter"
                (onChange)="onFilter()"
                (onClear)="onFilter()"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [autoDisplayFirst]="false"
                class="custom-dropdown bg-form"
                styleClass="w-12rem"
              />
            </div>

            <div class="container-select">
              <p-dropdown
                formControlName="exporter"
                placeholder="{{'AdminExportOffer.Table.ExporterColumn' | translate}}"
                [options]="exportersFilter"
                (onChange)="onFilter()"
                (onClear)="onFilter()"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [autoDisplayFirst]="false"
                class="custom-dropdown bg-form"
                styleClass="w-12rem"
              />
            </div>

            <div class="container-select">
              <p-dropdown
                formControlName="specie"
                placeholder="{{'AdminExportOffer.Table.SpecieColumn' | translate}}"
                [options]="speciesFilter"
                (onChange)="onFilter()"
                (onClear)="onFilter()"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [autoDisplayFirst]="false"
                class="custom-dropdown bg-form"
                styleClass="w-12rem"
              />
            </div>

            <div class="container-select">
              <p-dropdown
                formControlName="variety"
                placeholder="{{'AdminExportOffer.Table.VarietyColumn' | translate}}"
                [options]="varietiesFilter"
                (onChange)="onFilter()"
                (onClear)="onFilter()"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [autoDisplayFirst]="false"
                class="custom-dropdown bg-form"
                styleClass="w-12rem"
              />
            </div>

            <div class="container-select">
              <p-calendar
                formControlName="loadDate"
                placeholder="{{'AdminExportOffer.Table.LoadDateColumn' | translate}}"
                [showIcon]="true"
                (onSelect)="onFilter()"
                (onClearClick)="onFilter()"
                [showButtonBar]="true"
                [readonlyInput]="true"
                class="custom-input-calendar bg-form"
                styleClass="w-12rem"
              />
            </div>
          </div>
        </div>

      </form>
    </div>

    <p-table
      #dt1
      dataKey="exportOfferInfo.exportOffer.id"
      [value]="filteredExportOffers"
      [paginator]="true" [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [loading]="loading"
      [globalFilterFields]="[
      'exportOffer.id',
      'exportOffer.exporter.contactName',
      'exportOffer.variety.species.name',
      'exportOffer.variety.name',
      'exportOffer.created']"
      class="custom-table"
    >
      <ng-template pTemplate="header">
          <tr>
              <th id="offerId">
                  <div class="flex justify-content-center align-items-center">
                      {{'AdminExportOffer.Table.OfferIdColumn' | translate}}
                  </div>
              </th>
              <th id="exporter">
                  <div class="flex justify-content-center align-items-center">
                      {{'AdminExportOffer.Table.ExporterColumn' | translate}}
                  </div>
              </th>
              <th id="specie">
                  <div class="flex justify-content-center align-items-center">
                      {{'AdminExportOffer.Table.SpecieColumn' | translate}}
                  </div>
              </th>
              <th id="variety">
                  <div class="flex justify-content-center align-items-center">
                    {{'AdminExportOffer.Table.VarietyColumn' | translate}}
                  </div>
              </th>
              <th id="loadDate">
                  <div class="flex justify-content-center align-items-center">
                    {{'AdminExportOffer.Table.LoadDateColumn' | translate}}
                  </div>
              </th>
              <th id="price">
                  <div class="flex justify-content-center align-items-center">
                    {{'AdminExportOffer.Table.PriceColumn' | translate}}
                  </div>
              </th>
              <th id="actions">
                  <div class="flex justify-content-center align-items-center">
                    {{'AdminExportOffer.Table.ActionsColumn' | translate}}
                  </div>
              </th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-exportOfferInfo>
          <tr [pSelectableRow]="exportOfferInfo">
              <td>
                  <div class="flex justify-content-center align-items-center">
                      <p>{{exportOfferInfo.exportOffer.id}}</p>
                  </div>
              </td>
              <td>
                  <div class="flex justify-content-center align-items-center">
                      <p class="font-bold">{{exportOfferInfo.exportOffer.exporter.companyName}}</p>
                  </div>
              </td>
              <td>
                  <div class="flex justify-content-center align-items-center">
                      <p>{{exportOfferInfo.exportOffer.variety.species | speciesName}}</p>
                  </div>
              </td>
              <td>
                  <div class="flex justify-content-center align-items-center">
                      <p>{{exportOfferInfo.exportOffer.variety.name}}</p>
                  </div>
              </td>
              <td>
                  <div class="flex justify-content-center align-items-center">
                      {{exportOfferInfo.exportOffer.created | date: 'dd-MM-yyyy HH:mm'}}
                  </div>
              </td>
              <td>
                  <div class="flex justify-content-center align-items-center">
                      {{exportOfferInfo.exportOffer.listPrice}}
                  </div>
              </td>
              <td>
                  <div class="flex justify-content-center align-items-center gap-3">
                      <p-button
                        icon="pi pi-pencil"
                        (onClick)="goToAdminEdit(exportOfferInfo.exportOffer.id)"
                        pTooltip="{{'AdminExportOffer.Table.EditButton' | translate}}"
                        tooltipPosition="bottom"
                        class="action-btn pencil-icon"/>

                      <p-button
                        icon="pi pi-eye-slash"
                        *ngIf="exportOfferInfo.exportOffer.isActive"
                        pTooltip="{{'AdminExportOffer.Table.DeactivateButton' | translate}}"
                        tooltipPosition="bottom"
                        (onClick)="desactivate(exportOfferInfo.exportOffer)"
                        styleClass="p-button-warning"
                        class="action-btn eye-slash-icon"/>

                      <p-button
                        icon="pi pi-eye"
                        *ngIf="!exportOfferInfo.exportOffer.isActive"
                        pTooltip="{{'AdminExportOffer.Table.ActivateButton' | translate}}"
                        tooltipPosition="bottom"
                        styleClass="p-button-secondary"
                        (onClick)="activate(exportOfferInfo.exportOffer)"
                        class="action-btn eye-icon"/>

                      <p-button
                        icon="pi pi-trash"
                        *ngIf="!exportOfferInfo.exportOffer.isClosedSale"
                        pTooltip="{{'AdminExportOffer.Table.DeleteButton' | translate}}"
                        tooltipPosition="bottom"
                        styleClass="p-button-danger"
                        (onClick)="deleteOffer(exportOfferInfo.exportOffer)"
                        class="action-btn trash-icon"/>
                  </div>
              </td>
          </tr>
      </ng-template>
    </p-table>
  </div>
</app-admin-dashboard>

<p-confirmDialog [style]="{width: '30vw'}"></p-confirmDialog>
